import { Box, Grid2 as Grid, Typography, useMediaQuery, useTheme, TextField, Button, Alert, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import './contact.css';
import { useState } from 'react';



function Contact() {
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));


  const sanitizeText = (text) => {
    return text.replace(/[^a-zA-Z0-9 áéíóúÁÉÍÓÚ.,;:!?¡¿()-]/g, '');
  }

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccessMessage('');
    setErrorMessage('');

    // Sanitize and validate inputs
    const sanitizedSubject = sanitizeText(subject);
    const sanitizedMessage = sanitizeText(message);
    const sanitizedEmail = email.trim();

    let newErrors = {};
    if (!isValidEmail(sanitizedEmail)) newErrors.email = 'Correo inválido';
    if (!sanitizedSubject) newErrors.subject = 'Asunto requerido';
    if (!sanitizedMessage) newErrors.message = 'Mensaje requerido';

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // If no errors, proceed with the submission
      const payload = {
        email: sanitizedEmail,
        subject: sanitizedSubject,
        message: sanitizedMessage,
      };
      try {
        const response = await fetch('https://xfnbseug77.execute-api.us-east-1.amazonaws.com/api/mailing', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-key': process.env.REACT_APP_API_KEY, },
          body: JSON.stringify(payload),
        });
        // Clear inputs after successful submission
        if (response.ok) {
          setSuccessMessage('¡Mensaje enviado exitosamente!');
          setEmail('');
          setSubject('');
          setMessage('');
          setErrors({});
        } else {
          setErrorMessage('Ocurrió un error al enviar el mensaje. Intenta de nuevo.');
        }
      } catch (err) {
        setErrorMessage('Ocurrió un error al enviar el mensaje. Intenta de nuevo.');
      }
    }
  };

  return (
    <Box className="contact-section">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={8} className="contact-content">
          <Grid item size={isMobile ? 10 : 6} >
            <Typography variant="h3" className="title-contact" gutterBottom>
              Escríbenos
            </Typography>
            <TextField
              label="E-MAIL"
              fullWidth
              variant="standard"
              className="custom-textfield"
              value={email}
              onChange={e => setEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
              slotProps={{ input: { maxLength: 50 } }}
            />
            <TextField
              label="ASUNTO"
              fullWidth
              variant="standard"
              className="custom-textfield"
              value={subject}
              onChange={e => setSubject(e.target.value)}
              error={!!errors.subject}
              helperText={errors.subject}
              slotProps={{ input: { maxLength: 100 } }}
            />
            <Typography
              variant="body1"
              sx={{
                mb: 0,
                color: 'rgb(61, 28, 2)'
              }}
            >
              MENSAJE
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              sx={{
                mt: 0, mb: 3, '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: 'rgb(61, 28, 2)' },
                },
                backgroundColor: '#FFF'
              }}
              value={message}
              onChange={e => setMessage(e.target.value)}
              error={!!errors.message}
              helperText={errors.message}
              slotProps={{ input: { maxLength: 1000 } }}
            />
            <Button
              variant="contained"
              type="submit"
              sx={{
                bgcolor: 'rgb(230, 102, 113)', // Color del botón
                '&:hover': { bgcolor: '#FE0C33' },
                borderRadius: '25px',
                width: '150px',
              }}
            >
              Enviar
            </Button>
            <Box sx={{ mt: 2 }}>
              {successMessage && (
                <Alert action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setSuccessMessage('');
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                } severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>
              )}
              {errorMessage && (
                <Alert action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setErrorMessage('');
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                } severity="error" sx={{ mb: 2 }}>{errorMessage}</Alert>
              )}
            </Box>
          </Grid>

          <Grid item size={isMobile ? 10 : 6} className="contact-information-section">
            <Typography variant="h3" className="title-contact" gutterBottom>
              O Llámanos
            </Typography>
            <Typography variant="h5" className="text-contact-section">
              Atención al consumidor
            </Typography>
            <Typography variant="h4" className="title-contact-rosa">
              800 267 8362
            </Typography>
            <Typography variant="body1" className="text-contact-section">
              Lunes a viernes de 7:30 am. a 5:00 pm.
            </Typography>
          </Grid>
        </Grid>
      </form>

    </Box>
  );
}

export default Contact;